module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "chap1"
    }
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART OF IT")]), _vm._v(" started as a dare, sort of.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I was thinking how Massachusetts is crazy about giving its citizens days off for events it’s not really observing. For example, the third Monday in April is known as Patriots’ Day. Supposedly, the Commonwealth closes down to honor those who served in war. Actually, it just excuses us from work for the Boston Marathon. I once warned a friend who’d called me from Texas, a diehard Dallas Cowboys fan, that he’d have a tough time arriving here on Patriots’ Day. Awed, he said, “Y’all have a holiday for your football team?” In fact, Suffolk County alone sets aside March 17 for the Wearing of the Green. The Irish pols neutrally dubbed that one “Evacuation Day,” commemorating the momentous afternoon the colonists kicked the British troops out of Boston harbor. I’ve never mentioned Evacuation Day to the Texan; I’m afraid of what he’d think we were celebrating.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy Meagher said, “God, it’s freezing!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She was standing in front of me, my arms joined around her. Or, more accurately, around the tan L.L. Bean parka over bulky ski sweater over long johns that she was wearing. On a brutal Saturday evening in early December we were waiting with forty thousand other hardy souls on Boylston Street, across from the elevated patio of the Prudential Center, for the lighting of the Christmas tree. A fifty-foot spruce is given to the city of Boston each year by the province of Nova Scotia. The gift commemorates something else, but without a masking holiday, I can never remember what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A man on an accordion platform was adjusting a camera and klieg lights. Several hundred smarter folks watched from inside the windows of the Pru Tower or the new Hynes Convention Center. The smell of sausage and peppers wafted from somewhere near the Paris Cinema.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy said, “Unconscionable.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sorry?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is unconscionable not to start on time when it’s this cold.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hugging Nancy a little tighter, I looked around at our immediate neighbors. High school and college kids, not dressed sufficiently for the temperature, stamping their feet and stringing together ridiculous curses in the camaraderie of youth. Parents more my age, rubbing the mittened hands of their kids or wiping tiny red noses with wads of tissues pulled from pocket or handbag. A couple of cops in earmuffs, standing stoic but watchful. The crowd was well behaved so far, but occasionally you could hear coordinated shouting. If the Japanese restaurant behind and below us could have put up sake to go, they’d have made a fortune.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The weather really afflicted Nancy, but I was wearing just a rugby shirt under my coat and over my corduroy pants. Some Vikings must have come over the wall in my ancestors’ part of County Kerry, because I rarely feel the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To take Nancy’s mind off it, I said, “You know, this is where the finish line used to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The finish line?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of the marathon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No response.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I said, “The "), _c('i', [_vm._v("Boston")]), _vm._v(" Marathon?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She cricked her neck to frown at me. Black hair, worn a little longer since autumn, wide blue eyes, a sprinkling of freckles across the nose and onto both cheeks. “Not all of us are day-labor private investigators, John Cuddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Meaning?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Meaning I’ve lived in this city all my life, and I’ve never once seen the marathon in person.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You’re kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s too cold to kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But the marathon’s a holiday.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy shrugged off my arms. “When I was little, traffic was too snarled to come over here from South Boston. When I was in law school, I thanked God for the extra day and studied.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nance, even the courthouse closes for the marathon. What’s your excuse now?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I never knew anybody stupid enough to run that far.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s not stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Is not.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She almost smiled. “’Tis.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“’Tain’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I suppose you think you could run it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I suppose I could.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“John, you’re too big.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Six two and a little isn’t too big.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I meant you’re too heavy. The guys they show on TV are string beans.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“One ninety and a little isn’t that heavy. Besides, I’d train down for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“John, anyway you’re too …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy tried to swallow that last word, but I’d already heard it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I said, “Too what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Never mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Too old, is what you said. You think I’m too old to run the marathon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a feedback noise from an amplifier. Some “older” men were fiddling with a tall microphone on the patio under the tree. Then a male voice came over the public address system. “On behalf of the Prudential Center, I would like to welcome you to—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The rest of his comments were drowned out by the swelling cheer of the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Over the roar I said into Nancy’s ear, “Now it’s down the street a couple of blocks.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I said, now it’s down—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What is?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The finish line of the marathon. It used to be just about where we’re standing. But when Prudential decided to scale back its operations here, the John Hancock agreed to sponsor the race and moved the finish line down almost to the Tower.” I pointed to the Hancock, a Boston landmark of aquamarine glass now known more for its sky deck than for the four-by-ten windows that kept sproinging out and hurtling earthward just after it was built.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy didn’t turn her head. “Fascinating. And still stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At the mike a priest delivered a longish invocation. I let my eyes drift over to the Empire Insurance building. My former employer. I don’t think Empire ever sponsored so much as a Little League team.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The priest was followed by our Mayor Flynn, who was blessedly brief in his remarks. Then the premier of Nova Scotia began an interminable speech that I couldn’t follow. Nancy huddled back against me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("About ten feet from us, four guys wearing Boston College varsity jackets started a chant. “Light the fuckin’ tree, light the fuckin’ tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I laughed. Nancy muttered, “You’re contemptible.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Finally, Harry Ellis Dickson, the conductor emeritus of the Boston Pops Orchestra, had his turn. He introduced Santa to much squealing and wriggling among the kids, many of whom were hoisted by dads and moms onto shoulders. Then Harry led the crowd through several carols. “O Come, All Ye Faithful,” “Joy to the World,” “Hark, the Herald Angels Sing.” Everybody knew the first few lines, most of us dah-dah-ing the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Between carols Nancy sighed. “We’ve become a one-stanza society.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Two slim figures in oddly modified Santa outfits danced up the steps of the patio.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy said, “Who are they supposed to be?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Santa’s eunuchs.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Again she shrugged off my arms. “I take it back. You’re beneath contempt.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("After a few more carols the star on top of the tree was lit, setting off a reaction in the crowd like the first firecracker on the Fourth of July. The long vertical strips of lights came on next. Then, beginning at the top, sequential clumps mixing red, blue, green, and yellow flashed to life, more a shimmer than individual bulbs, until the magic had hopped down the entire tree.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We finished with a universal “Silent Night,” the crowd breaking up while the last notes echoed off the buildings.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Maybe a half each left?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy shook her head as I held the bottle of Petite Sirah poised over her glass. She had traded the sweater and long johns for a puffy print blouse that brought out the color of her eyes. We were sitting at the dining table of the condo I rented from a doctor doing a program in Chicago. Only a couple of blocks north of the Pru, it was a short but cold walk from the tree-lighting ceremony.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cold in more ways than one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy said, “I cooked, so you clean.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I corked the wine and cleared the table of the remains of a pretty good meal of lamb chops with mushroom-and-sausage rice. My praising the food, even its color and arrangement on the plate, hadn’t done much to warm Nancy up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("From the kitchen I said, “We can talk about it, or we can brood about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No reply.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I loaded the dishwasher and sponged down the sink and counter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Back in the living room, Nancy was sitting stiffly on the burlappy sofa, using her index finger to swipe tears angrily from the sides of her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nancy—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Just shut up, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I stopped dead.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She said, “I hate to cry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I believed that. As an assistant district attorney, Nancy had seen an awful lot. A person who cried easily wouldn’t get through one of her typical days, much less the couple of years she’d put in.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I said, “Is it one of your cases?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Shake of the head.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Medical? Physical?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, dammit, it’s you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My face? My breath? My—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Goddammit, John. It’s …”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I walked toward her. Not told to stop, I sat next to her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy turned sideways to me, took a breath. “Look, it’s not easy for me to talk about my emotions. It never has been.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hasn’t affected—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t interrupt, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She took another breath. “My dad died when I was little, John. Three years old. They didn’t have a tree-lighting ceremony in Southie, but even if they had, I didn’t have him to swing me up onto his shoulders to watch it. I really don’t remember him, not from real life. Just his face in photos, the pictures Mom kept. Holidays, especially Christmas, were hard on her because she did remember him from real life.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I thought back to my holidays with Beth, then to the period after I’d lost her to cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Once Mom died, my last year of law school, I didn’t like the holidays anymore. All I’d had of the early ones was Mom, trying her best to be both parents at once. The later ones, I was always kind of propping her up, keeping her in the spirit of the season. When I rented the Lynches’ top floor, they tried to include me in their stuff, but it was awkward, you know? I wasn’t anybody’s niece or girlfriend or anything. I was just the poor tenant with no place else to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And then?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I met you. And for the first time, I thought I had somebody to share the holidays with. Really enjoy them, equal to equal, nobody making up for anything. I’ve been looking forward to the tree-lighting for weeks, then you behave like a freshman on his first trip to the big city.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I thought she was overreacting, but I said, “I’m sorry, Nance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No. No, you’re not. You don’t even understand what I mean, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I understand. I guess what happened in my life just turned me a different direction as far as the holidays go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She sniffled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I said, “Maybe you just got under my skin a little over the marathon.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A sour face. “You big turd.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Finally, a term of endearment.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She punched me on the arm. A little hard, but now playfully. “That rugby shirt doesn’t even fit anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Standing, I pulled it over my head, whirling it by a sleeve and letting it fly across the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nancy looked at my pants. “Never cared much for those corduroys, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Leaning forward, I braced my hands on the back of the sofa to either side of her head. “Lady, are you trying to get me into bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That depends.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“On what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“On how much harder I have to try.”")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Afterward, we lay in the dark under just a sheet. The window was open a crack, the wind whistling through. I was on my back, Nancy on her side, cuddled up against me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“John, you ever think it’s odd, the way we talk about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Can’t be helped. Catholic upbringing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No. I don’t mean "), _c('i', [_vm._v("us")]), _vm._v(" us. I mean people in general. We call it ‘making love.’”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“As opposed to …?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I mean, it just sounds so mechanical, almost like a label for some manufacturing process.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s worse than that, Nance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We tend to say, ‘I want to make love to you.’”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Using ‘to you’ makes it sound like a one-way street. Provider to customer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How does ‘I want to make love with you’ sound?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Pretty good, except we’ll have to wait a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She snuggled closer. “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, a man my age takes two, three weeks to recharge.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Another punch to the arm. “You’re still sore from the marathon remark.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m still sore from where you punched me before.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Man your age, decides to run the marathon, he’d better get used to pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I shifted my face to Nancy even though I couldn’t see her in the dark. “What makes you think I’m going to run the marathon?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The look you gave me after I almost kept from saying you were too old for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What kind of look was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A stupid look.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I shifted again, about to talk to the ceiling, when the telephone rang. That started the rest of it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6edca3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-start.vue
// module id = 72
// module chunks = 0